module.exports = "/assets/data/03d982011ba82455545c536a30680232-HP14.data.json";